var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      ref: "modal",
      attrs: {
        title: _vm.$t(_vm.modalTitle),
        titleIcon: "/images/icons/ic-warning-circle.svg",
        "aria-labelledby": "audienceBulkAddToProductModal",
        overflow: true,
        loading: _vm.loading,
        action: "Grant Product Access",
        disableAction: !_vm.confirm,
        "secondary-action": "Cancel"
      },
      on: { cta: _vm.handleCta, "secondary-cta": _vm.hide }
    },
    [
      _c("Transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _vm.isCurrentPromptProductSelection && !_vm.loading
          ? _c("div", { key: "select-product" }, [
              _c("form", { attrs: { id: "audience_bulk_tagging_form" } }, [
                _c(
                  "div",
                  { staticClass: "overflow-visible" },
                  [
                    _c("AppDropdown", {
                      staticClass: "product-dropdown",
                      attrs: {
                        border: true,
                        value: _vm.selectedProduct,
                        options: _vm.availableProducts,
                        searchable: true,
                        placeholder: "Select a product",
                        "image-width": "23px",
                        "right-align": false,
                        "display-label": "name",
                        label: "name",
                        AppDropdown: true,
                        small: false,
                        "rounded-icons": true
                      },
                      on: { select: _vm.selectProduct }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.formErrors &&
                              _vm.formErrors.productSelectionErrors,
                            expression:
                              "formErrors && formErrors.productSelectionErrors"
                          }
                        ],
                        staticClass: "para-3 text-danger mb-2"
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.formErrors.productSelectionErrors) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          : !_vm.isCurrentPromptProductSelection && !_vm.loading
          ? _c("div", { key: "confirm" }, [
              _c("div", { staticClass: "confirmation-card" }, [
                _c("div", { staticClass: "confirmation-count" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$commonHelper.formatNumber(_vm.tableTotalCustomers, {
                        decimals: 0
                      })
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "confirmation-label" }, [
                  _vm._v("Recipients")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "w-100 mt-3 highlight-card" },
                [
                  _c(
                    "AppCheckbox",
                    {
                      model: {
                        value: _vm.confirm,
                        callback: function($$v) {
                          _vm.confirm = $$v
                        },
                        expression: "confirm"
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\tAre you sure you want to grant product access to\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "customer-count" }, [
                        _vm._v(
                          _vm._s(_vm.tableTotalCustomers) +
                            " " +
                            _vm._s(_vm.customerText)
                        )
                      ]),
                      _vm._v("?\n\t\t\t\t")
                    ]
                  )
                ],
                1
              )
            ])
          : _c(
              "div",
              { key: "loading" },
              [
                _c(
                  "div",
                  { staticClass: "importing-animation" },
                  [
                    _c("InlineSvg", {
                      attrs: { src: "/images/icons/ic-box.svg" }
                    }),
                    _vm._v(" "),
                    _c("InlineSvg", {
                      attrs: { src: "/images/icons/ic-box.svg" }
                    }),
                    _vm._v(" "),
                    _c("InlineSvg", {
                      attrs: { src: "/images/icons/ic-box.svg" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("AppProgress", {
                  attrs: {
                    min: 0,
                    max: _vm.totalCustomers,
                    value: _vm.processedCount
                  }
                })
              ],
              1
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }